module.exports = __webpack_public_path__ + "img/promotion1.51802f8c.png";